import type { OrderPageData, PassOrderPageData } from '../../api';

/**
 * The widget sells either a bookable order page or a pass product, and `OrderPageState.orderPage`
 * holds whichever one applies. Most of the widget only ever sees the bookable kind, but the shell,
 * the personal-details step and the payment step are shared by both flows.
 */
export type WidgetOrderPageData = OrderPageData | PassOrderPageData;

export const isOrderPageData = (page: WidgetOrderPageData): page is OrderPageData => Array.isArray(page?.price);

export const asOrderPageData = (page: WidgetOrderPageData): OrderPageData | undefined =>
  isOrderPageData(page) ? page : undefined;

export type DateAndTimeDetails = {
  date: string | null;
  time?: number | null;
  courseId?: string;
};
